export default {"src":"/_next/static/media/features-my-playlists.1b85e683.gif","height":540,"width":800};